import {createAction} from '@reduxjs/toolkit';

export const selectFeatureRef = createAction('SELECT_FEATURE_REF');
export const deselectFeatureRef = createAction('DESELECT_FEATURE_REF');
